import { useEffect, useState } from "react";
import { DropdownSelect } from "@vds/selects";
import { ChildContainer } from "../../../global/components/OnboardingFormStyles/Styles";
import {
  NewLoaderContainer,
  AreaFloorContainer,
} from "../discoveredCameraOnboarding/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  clearOnboardingFields,
  disableNextButton,
  fetchArea,
  fetchFloor,
  fetchSite,
} from "../../../store/actions";
import { ImageDownloadMedia } from "../../../model/mediaService";
import { Loader } from "@vds/loaders";
import { Line } from "@vds/lines";
import {
  getSiteInfoFromFloor,
  getSitesAndFloorsData,
} from "../../../global/utility/Utils";
import FloorPlan from "../../../global/components/floorPlan/FloorPlan";
import { Body } from "@vds/typography";

const LocationSelection = ({
  onImageDownloadFailed,
  camDetails,
  onPositionChange,
  onNextDisableChange,
  editFlow,
  onBoradType,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const siteTagList = useSelector((state) => {
    return state.sitesReducer.siteTagList;
  });
  const [allFloors, setAllFloors] = useState([]);
  const dispatch = useDispatch();
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { cameraList, discoveredCamerasList } = useSelector(
    (state) => state?.deviceReducer
  );
  const [localPosition, setLocalPosition] = useState(
    camDetails?.customdata?.cameralocation || { top: 0, left: 0 }
  );

  const {
    companionDevice,
    floorObject,
    areaObject,
    selectedCamQR,
    unpairedCamDetails,
    disableButton,
    camPosition,
  } = useSelector((state) => state.cameraOnboardingReducer);
  const { companionDeviceList } = useSelector((state) => state?.deviceReducer);
  const [floorAreas, setFloorAreas] = useState([]);
  const [cameraObj, setCameraObj] = useState([]);

  const locationList = getSitesAndFloorsData(siteTagList);
  const allAreas = locationList?.areas;

  useEffect(() => {
    if (companionDevice?.id && floorObject?.id && !floorObject?.imageurl) {
      handleFloorChange(floorObject?.id);
    }
  }, [floorObject?.id, allFloors, companionDevice?.id]);
  const fetchFloorImage = async (imageId) => {
    try {
      setIsLoading(true);
      onImageDownloadFailed(false);
      const imageUrl = await ImageDownloadMedia(imageId, activeSession);

      if (!imageUrl) {
        onImageDownloadFailed(true);
        setIsLoading(false);
        return null;
      }
      setIsLoading(false);
      return imageUrl;
    } catch (error) {
      console.error("Error downloading image:", error);
      onImageDownloadFailed(true);
      setIsLoading(false);
      return null;
    }
  };

  const handleFloorChange = async (selectedFloorId) => {
    if (!editFlow) {
      dispatch(clearOnboardingFields(["areaObject", "siteObject"]));
    }
    setFloorAreas([]);
    const selectedFloor = allFloors?.find(
      (floor) => floor.id === selectedFloorId
    );
    if (!selectedFloor) {
      onNextDisableChange(true);
      if (!editFlow || selectedFloorId == "") {
        dispatch(clearOnboardingFields(["floorObject"]));
      }
      return;
    }
    const filteredAreas = allAreas?.filter((area) =>
      area.tagids?.includes(selectedFloorId)
    );
    setFloorAreas(filteredAreas);

    if (!selectedFloor.imageid) {
      onNextDisableChange(true);
      if (!editFlow || selectedFloorId == "") {
        dispatch(clearOnboardingFields(["floorObject"]));
      }
      return;
    }
    try {
      onNextDisableChange(false);
      const floorImageUrl = await fetchFloorImage(selectedFloor?.imageid);
      dispatch(
        fetchFloor({
          name: selectedFloor?.name,
          id: selectedFloorId,
          imageid: selectedFloor?.imageid,
          imageurl: floorImageUrl,
        })
      );
    } catch (error) {
      console.error("Error fetching floor image:", error);
    }
  };
  const handleAreaChange = (e) => {
    const selectedAreaId = e.target.value;
    const selArearName = e.target[e.target.selectedIndex].text;
    dispatch(fetchArea({ id: selectedAreaId, name: selArearName }));
  };

  useEffect(() => {
    const filteredAreas = allAreas?.filter((area) =>
      area.tagids?.includes(floorObject?.id)
    );
    setFloorAreas(filteredAreas);
    if (
      !areaObject?.id ||
      !floorObject?.id ||
      areaObject?.id == "" ||
      floorObject?.id == ""
    ) {
      dispatch(disableNextButton(true));
      onNextDisableChange(true);
    } else if (areaObject?.id && floorObject?.id) {
      onNextDisableChange(false);
      dispatch(disableNextButton(false));
    }
  }, [floorObject, areaObject, companionDevice, editFlow]);

  useEffect(() => {
    try {
      const siteInfo = getSiteInfoFromFloor(floorObject?.id, siteTagList);
      dispatch(fetchSite({ name: siteInfo?.name, id: siteInfo?.id }));
    } catch (err) {
      console.log(err);
    }
  }, [floorObject]);

  useEffect(() => {
    (async () => {
      try {
        if (companionDevice?.id) {
          const companionDeviceDetails = companionDeviceList.find(
            (copmanion) => copmanion.id == companionDevice?.id
          );
          if (
            companionDeviceDetails &&
            companionDeviceDetails?.siteids?.length
          ) {
            const siteIds = companionDeviceDetails?.siteids;
            const floorData = siteTagList?.floors.filter((f) => {
              try {
                return f.tagids && siteIds.indexOf(f.tagids[0]) > -1;
              } catch (error) {
                return false;
              }
            });

            if (floorData?.length) {
              setAllFloors(floorData.flat());
            }
          }
        }
      } catch (error) {
        console.error("Error fetching site list:", error);
      }
    })();
  }, [companionDevice]);

  const updateCamPosition = ({ top, left }) => {
    const newPosition = { top, left };
    setLocalPosition(newPosition);
    onPositionChange(newPosition);
  };

  useEffect(() => {
    const tempCamObj = cameraList?.filter(
      (item) => item?.refid === selectedCamQR
    );
    if (tempCamObj && tempCamObj?.length) {
      let top = camPosition?.top;
      let left = camPosition?.left;

      if (
        editFlow &&
        (!top || top === 0) &&
        (!left || left === 0) &&
        camDetails?.customdata?.cameralocation
      ) {
        top = camDetails.customdata.cameralocation.top;
        left = camDetails.customdata.cameralocation.left;
        onPositionChange({ top, left });
      }
      if (editFlow) {
        if (top !== undefined) {
          if(tempCamObj[0]?.customdata && !tempCamObj[0].customdata.cameralocation){
            tempCamObj[0].customdata = {...tempCamObj[0].customdata, cameralocation: {...tempCamObj[0].customdata.cameralocation, top}};
          }
          tempCamObj[0].customdata.cameralocation.top = top;
          onPositionChange({ top, left });
        }

        if (left !== undefined) {
          tempCamObj[0].customdata.cameralocation.left = left;
          onPositionChange({ top, left });
        }
        setCameraObj(tempCamObj);
      }
    }
  }, [selectedCamQR && cameraList, camPosition]);

  return (
    <ChildContainer>
      {onBoradType !== "Manual" && <Line type="secondary" />}
      <br />
      <Body size="large">
        {onBoradType === "Manual"
          ? ""
          : "Select the floor plan that where this camera is located. Then, drag and drop the camera icon so that its location on the floor plan corresponds to it’s location on your site."}
      </Body>
      <br />
      <AreaFloorContainer>
        <DropdownSelect
          label="Floor plan"
          onChange={(e) => {
            handleFloorChange(e.target.value);
            dispatch(clearOnboardingFields(["areaObject"]));
          }}
          readOnly={false}
          required={true}
          inlineLabel={false}
          width="226px"
          disabled={!companionDevice?.id}
        >
          <option value="">Select Floor</option>
          {allFloors &&
            allFloors?.map((floor) => (
              <option
                selected={floorObject?.id === floor?.id}
                key={floor?.id}
                value={floor?.id}
              >
                {floor?.name}
              </option>
            ))}
        </DropdownSelect>

        <DropdownSelect
          label="Area"
          onChange={handleAreaChange}
          required={true}
          width="226px"
          disabled={!companionDevice?.id || !floorObject?.id}
          inlineLabel={false}
        >
          <option value="">Select area</option>
          {floorAreas?.map((area) => (
            <option
              selected={areaObject?.id === area?.id}
              key={area.id}
              value={area.id}
            >
              {area.name}
            </option>
          ))}
        </DropdownSelect>
      </AreaFloorContainer>
      <br />
      {floorObject && (
        <div>
          {isLoading && (
            <NewLoaderContainer>
              <Loader fullscreen={false} active={true} />
            </NewLoaderContainer>
          )}
          {floorObject && floorObject?.imageurl ? (
            editFlow == false || onBoradType == "Manual" ? (
              <FloorPlan
                floorImage={floorObject?.imageurl}
                isEditable={false}
                FloorSize={[464, 332]}
                unPairedCam={{ customdata: { cameralocation: localPosition } }}
                onChangeCamPosition={updateCamPosition}
                isManual={true}
              />
            ) : (
              cameraObj &&
              cameraObj.length && (
                <FloorPlan
                  cameras={cameraObj}
                  floorImage={floorObject?.imageurl}
                  FloorSize={[464, 332]}
                  isEditable={true}
                  onChangeCamPosition={updateCamPosition}
                  isManual={true}
                />
              )
            )
          ) : (
            ""
          )}
        </div>
      )}
    </ChildContainer>
  );
};

export default LocationSelection;
